<template>
  <v-card>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title style="width: 100%;">
        <v-layout class="pa-0 ma-0" row>
          <StatusIndicator class="ma-2" positive pulse v-if="updateInfo"> </StatusIndicator>
          <h1 class="subheading">{{ $t("labels.toDay") }} {{ $t("pageHeader.comment") }}</h1>
          <v-spacer> </v-spacer>
          <h1 class="subheading">{{ comments.length }}</h1>
        </v-layout>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text class="list-350">
      <v-progress-linear v-if="isLoading" size="70" width="7" indeterminate> </v-progress-linear>
      <v-layout column="column" v-if="!isLoading">
        <template v-for="(row, index) in comments">
          <v-layout class="pointer" column="column" @click="viewLocationNewTab(row)">
            <v-flex class="pb-0">
              <v-layout>
                <v-flex class="font-weight-medium green--text">{{ row.userName }}</v-flex>
                <v-spacer> </v-spacer>
                <v-flex class="caption text-xs-right" color="text--gray"
                  >{{ row.createDateTime | moment("from", "now") }}
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="pt-0">
              <v-layout>
                <v-flex>
                  <span class="caption list-line">{{ row.comment }}</span>
                  <span class="caption ml-1">- </span>
                  <span class="caption ml-1 red--text">{{ type(row) }}</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-divider v-if="index + 1 < comments.length" :key="index"> </v-divider>
        </template>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import dashbaordService from "../service.js";
import { StatusIndicator } from "vue-status-indicator";
// import "vue-status-indicator/styles.css";

export default {
  data() {
    return {
      comments: [],
      isLoading: true,
      updateInfo: false
    };
  },
  sockets: {
    comment(data) {
      this.getAll();
      this.updateInfo = true;
    }
  },
  mounted() {
    this.getAll();
  },
  components: {
    StatusIndicator
  },
  methods: {
    type(row) {
      let value = null;
      switch (row.typeID) {
        case 1:
          value = "store";
          break;
        case 2:
          value = "organization";
          break;
        case 3:
          value = "tickets";
          break;
        case 4:
          value = "leads";
          break;
        case 5:
          value = "reconcile";
          break;
        default:
          value = "";
      }
      return value;
    },
    viewLocationNewTab(row) {
      console.log("pressed", row);
      let url = null;
      switch (row.typeID) {
        case 1:
          url = "/location/profile";
          break;
        case 2:
          url = "/organization/profile";
          break;
        case 3:
          url = "/tickets/profile";
          break;
        case 4:
          url = "/leads/profile";
          break;
        case 5:
          url = "/location/profile";
          break;
        default:
          url = "none";
      }
      if (url !== "none") {
        this.$router.push({ path: `${url}/${row.storeID}?type=${row.typeID}` });
        this.updateInfo = false;
        // let routeData = this.$router.resolve({ path: `${url}/${row.fromId}` });
        // window.open(routeData.href, '_blank');
      }
    },
    getAll() {
      return dashbaordService
        .getLastComment()
        .then(result => {
          console.log("comment list", result);
          this.comments = result.data;
          this.isLoading = false;
        })
        .catch(err => {
          console.log("result err", err);
        });
    }
  }
};
</script>

<style scoped></style>
